<template>
  <div v-if="stakeRewards && stakeRewards.length > 0">
    <b-table
      :data="stakeRewards"
      class="table"
    >
      <template slot-scope="props">

        <b-table-column field="reward" label="Reward">
            {{ props.row.rewardHistory.stakingReward }}
        </b-table-column>

        <b-table-column field="difference" label="Difference">
            {{ props.row.rewardHistory.difference }}
        </b-table-column>

        <b-table-column field="timeStamp" label="Time">
          <v-tooltip bottom>
              <span slot="activator">
                  <timeago
                    :datetime="props.row.rewardHistory.timestamp"
                    :auto-update="10">
                  </timeago>
              </span>
              <span>{{ new Date(props.row.rewardHistory.timestamp).toISOString() }}</span>
            </v-tooltip>
        </b-table-column>

      </template>
    </b-table>
    <el-pagination
      small
      background
      @current-change="shift"
      @prev-click="shift(current_page-1)"
      @next-click="shift(current_page+1)"
      :current-page="current_page"
      layout="prev, pager, next"
      :pager-count=5
      :page-size="pageSize"
      :total="totalStakeRewards">
    </el-pagination>
  </div>
  <Empty v-else/>
</template>

<script>
import { mapGetters } from 'vuex';
import Empty from '../reusables/empty.vue';

export default {
  name: 'StakeRewards',
  props: ['address'],
  components: {
    Empty,
  },
  data() {
    return {
      current_page: 1,
      pageSize: 10,
    };
  },
  computed: {
    ...mapGetters(['stakeRewards', 'totalStakeRewards']),
  },
  watch: {
    '$route.params.address': function () {
      this.shift(1);
    },
  },
  methods: {
    shift(page) {
      this.$store.dispatch('fetchStakeRewards', {
        address: this.address,
        limit: this.pageSize,
        page,
      });
      this.current_page = page;
    },
  },
  created() {
    this.shift(1);
  },
};
</script>
